// src/pages/BillingSuccess.jsx
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function normalizeLang(search, i18nLanguage) {
  const params = new URLSearchParams(search || "");
  const raw = String(params.get("lang") || i18nLanguage || "es").toLowerCase();
  return ["es", "en", "fr"].includes(raw) ? raw : "es";
}

function withLang(pathname, lang) {
  return `${pathname}?lang=${encodeURIComponent(lang)}`;
}

const COPY = {
  es: {
    eyebrow: "Checkout externo",
    title: "Checkout finalizado",
    body:
      "Has llegado a la ruta de finalización del checkout. Esta pantalla es únicamente informativa.",
    notice:
      "En esta fase TEST no se valida el pago, no se activa un plan y no se escribe en la base de datos. El estado real de la suscripción debe confirmarse mediante el flujo interno que se implemente posteriormente.",
    primary: "Volver a Precios",
    secondary: "Ir al inicio",
  },
  en: {
    eyebrow: "External checkout",
    title: "Checkout completed",
    body:
      "You have reached the checkout completion route. This screen is informational only.",
    notice:
      "During this TEST phase, no payment is verified, no plan is activated, and nothing is written to the database. The actual subscription status must be confirmed by the internal flow implemented later.",
    primary: "Back to Pricing",
    secondary: "Go to home",
  },
  fr: {
    eyebrow: "Paiement externe",
    title: "Paiement terminé",
    body:
      "Vous avez atteint la route de fin du paiement. Cet écran est uniquement informatif.",
    notice:
      "Pendant cette phase TEST, aucun paiement n'est vérifié, aucun forfait n'est activé et aucune donnée n'est écrite dans la base. L'état réel de l'abonnement devra être confirmé par le flux interne mis en place ultérieurement.",
    primary: "Retour aux tarifs",
    secondary: "Aller à l'accueil",
  },
};

export default function BillingSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = normalizeLang(location.search, i18n.language);
  const copy = COPY[lang];

  return (
    <main className="min-h-screen bg-slate-50 px-6 py-12 text-slate-900">
      <section className="mx-auto max-w-3xl">
        <div className="rounded-3xl border border-emerald-100 bg-white p-8 shadow-sm sm:p-10">
          <p className="text-sm font-semibold uppercase tracking-wide text-emerald-700">
            {copy.eyebrow}
          </p>

          <h1 className="mt-3 text-3xl font-bold tracking-tight text-emerald-950 sm:text-4xl">
            {copy.title}
          </h1>

          <p className="mt-5 text-base leading-7 text-slate-700">{copy.body}</p>

          <div className="mt-6 rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm leading-6 text-sky-900">
            {copy.notice}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => navigate(withLang("/pricing", lang))}
              className="rounded-xl bg-emerald-700 px-5 py-3 font-semibold text-white transition hover:bg-emerald-800"
            >
              {copy.primary}
            </button>

            <button
              type="button"
              onClick={() => navigate(withLang("/", lang))}
              className="rounded-xl border border-slate-300 bg-white px-5 py-3 font-medium text-slate-900 transition hover:bg-slate-50"
            >
              {copy.secondary}
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
